import React, { ChangeEvent, FC, useEffect, useState } from "react";
import { IProps } from "./types";
import styles from "./styles.module.scss";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowDownIcon, ArrowSmallDownIcon } from "../../assets";
import { Button, CheckBox, SearchInput } from "..";
import clsx from "clsx";
import { getTags } from "../../services/recipe.service";
import { getCategories } from "../../services/category.service";
import { getAppVersions } from "../../services/appVersion.service";
import { useDebounce } from "../../hooks";

interface ITags {
  value: string;
  usage: number;
}
const Types = ["Feedback", "Issue"];

const FeedbackFilter: FC<IProps> = ({
  filterSelectedVersions,
  setFilterSelectedVersions,
  filterTypes,
  setFilterTypes,
  setIsOpen,
}): JSX.Element => {
  const [isShowTypesList, setIsShowTypesList] = useState(false);
  const [isShowVersionsList, setIsShowVersionsList] = useState(false);

  const [isLoadingVersions, setIsLoadingVersions] = useState(false);
  const [search, setSearch] = useState<string>("");
  const debounceSearch = useDebounce(search, 600);

  const [appVersions, setAppVersions] = useState<string[]>([]);

  const onGetVersions = async (search?: string) => {
    try {
      setIsLoadingVersions(true);
      const { data } = await getAppVersions(search);
      console.log(data?.data);

      if (data?.data) {
        setAppVersions(data?.data?.appVersions ?? []);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingVersions(false);
    }
  };

  const onChangeSearch = (e: ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  useEffect(() => {
    onGetVersions(debounceSearch);
  }, [debounceSearch]);

  return (
    <motion.div
      initial={{ scale: 0.8, opacity: 0.5 }}
      animate={{ scale: 1, opacity: 1 }}
      className={styles.wrapper}
    >
      <h5 className={styles.title}>Filter</h5>
      <div className={styles.sectionDevider} />
      <div
        onClick={() => setIsShowTypesList((prev) => !prev)}
        className={styles.sectionHeader}
      >
        <span className={styles.sectionTitle}>Type</span>
        <ArrowDownIcon
          className={clsx({
            [styles.arrowOpen]: isShowTypesList,
            [styles.arrowClosed]: !isShowTypesList,
          })}
        />
      </div>
      <AnimatePresence>
        {isShowTypesList && (
          <motion.div
            initial={{ height: 0, marginTop: 0 }}
            animate={{ height: 52, marginTop: 10 }}
            exit={{ height: 0, marginTop: 0 }}
            className={styles.listContainer}
          >
            {Types.map((item, index) => {
              const isChecked = filterTypes.includes(item);
              const onSelect = () => {
                if (isChecked) {
                  setFilterTypes(filterTypes.filter((el) => el !== item));
                } else {
                  setFilterTypes([...filterTypes, item]);
                }
              };

              return (
                <div key={index} className={styles.selectorItem}>
                  <CheckBox isChecked={isChecked} setIsChecked={onSelect} />
                  <span
                    style={{ color: isChecked ? "#11142D" : "#808191" }}
                    className={styles.selectorItemText}
                  >
                    {item}
                  </span>
                </div>
              );
            })}
          </motion.div>
        )}
      </AnimatePresence>

      <div className={styles.sectionDevider} />

      <div
        onClick={() => setIsShowVersionsList((prev) => !prev)}
        className={styles.sectionHeader}
      >
        <span className={styles.sectionTitle}>App version</span>
        <ArrowDownIcon
          className={clsx({
            [styles.arrowOpen]: isShowVersionsList,
            [styles.arrowClosed]: !isShowVersionsList,
          })}
        />
      </div>
      <AnimatePresence>
        {isShowVersionsList && (
          <motion.div
            initial={{ height: 0, marginTop: 0 }}
            animate={{ height: 310, marginTop: 10 }}
            exit={{ height: 0, marginTop: 0 }}
            className={styles.listContainer}
          >
            <div className={styles.searchContainer}>
              <SearchInput
                placeholder="Search"
                value={search}
                onChange={onChangeSearch}
                className={styles.search}
              />
            </div>
            <div className={styles.listContainerVersions}>
              {appVersions
                .filter((item) => item.includes(search))
                .map((item, index) => {
                  const isChecked = filterSelectedVersions.includes(item);
                  const onSelect = () => {
                    if (isChecked) {
                      setFilterSelectedVersions(
                        filterSelectedVersions.filter(
                          (version) => version !== item
                        )
                      );
                    } else {
                      setFilterSelectedVersions([
                        ...filterSelectedVersions,
                        item,
                      ]);
                    }
                  };

                  return (
                    <div key={index} className={styles.selectorItem}>
                      <CheckBox isChecked={isChecked} setIsChecked={onSelect} />
                      <span
                        style={{ color: isChecked ? "#11142D" : "#808191" }}
                        className={styles.selectorItemText}
                      >
                        {item}
                      </span>
                    </div>
                  );
                })}
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <div className={styles.sectionDevider} />
      {/* <Button
        onClick={() => {
          setIsOpen(false);
        }}
        title="Show recipes"
        size="small"
        styleType="filled"
      /> */}
      <div
        onClick={() => {
          setFilterSelectedVersions([]);
          setFilterTypes([]);
        }}
        className={styles.resetButton}
      >
        <div>Reset all filters</div>
      </div>
    </motion.div>
  );
};

export default FeedbackFilter;
